<template>
  <card class="card--my-event" :class="badgeStyle">
    <div class="event-card my-event__card">
      <div class="my-event__card-top">
        <h3 class="my-event__card-title">{{ event.event.title }}</h3>
      </div>
      <p class="my-event__card-date">{{ event.event.startdate | formatDate }}</p>
      <p class="event-card__label my-event__card-price">
        <icon class="icon--price" symbol="icon-price"/>
        <span class="event-card__label-text">{{ totalPrice }}</span>
      </p>
      <p class="event-card__label my-event__card-price" v-if="event.price_text">
        <icon class="icon--pdf" symbol="icon-vehicle"/>
        <span class="event-card__label-text">{{ event.price_text }}</span>
      </p>
      <p class="event-card__label my-event__card-location">
        <icon class="icon--location" symbol="icon-location"/>
        <span class="event-card__label-text"><a :href="event.event.eventlocation.mapslink"
                                                target="_blank">{{ event.event.eventlocation.city }}</a></span>
      </p>
      <p class="event-card__pdf">
        <a class="event-card__label" :href="invoiceLink(event.id)" target="_blank">
          <icon class="icon--pdf" symbol="icon-pdf"/>
          <span class="event-card__label-text">{{ $t('myReservations.invoice') }}</span>
        </a>
      </p>
      <p class="event-card__number" v-if="event.event.hasnums">
        Nummer: <span class="event-card__label-text">{{ event.nums }}</span>
      </p>
      <p class="event-card__number" v-else>
        Platz wird am Flohmarkttag vom Veranstalter zugeteilt
      </p>
      <p class="event-card__plan" v-if="event.event.hasnums">
        <button class="show__plan" @click="showPlansHandler">Flohmarktplan zeigen</button>
      </p>
      <p class="event-card__info" v-if="event.usercomment">
        {{ event.usercomment }}
      </p>
      <div class="my-event__card-c2a">
        <a role="button" href="javascript:;" class="my-event__delete" v-if="!isConfirmed"
           @click="deleteEventHandler(event.id)">{{ $t('myReservations.delete') }}</a>
        <a role="button" href="javascript:;" class="my-event__delete" v-else
           @click="openHandler">{{ $t('myReservations.emailConfirmation') }}</a>
        <span class="my-event__card-status">{{ $t(`myReservations["${event.status}"]`) }}</span>
      </div>
    </div>


    <portal to="email-confirmation">
      <overlay :is-active="isOpened" @close="isOpened = false">
        <template #content>
          <h1>{{ $t('myReservations.confirmation') }}</h1>
          <div class="email-confirmation" v-html="event.emailmessage"/>
        </template>
      </overlay>
    </portal>

  </card>
</template>

<script>
import {formatDate} from "../helpers/filters";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import {mapActions} from 'vuex'
import {bookingPlansPhotoSwipe} from '@/vendors/photo-swipe'

export default {
  name: "AppMyEventCard",
  props: {
    event: {
      type: Object
    }
  },
  filters: {
    formatDate
  },
  data() {
    return {
      isOpened: false,
      plansList: [
        {src: require('@/assets/images/eg-floor.jpg'), w: 800, h: 600},
        {src: require('@/assets/images/1-floor.jpg'), w: 800, h: 600},
        {src: require('@/assets/images/2-floor.jpg'), w: 800, h: 600}
      ]
    }
  },
  computed: {
    isConfirmed() {
      return this.event.status === '2'
    },
    badgeStyle() {
      return this.event.status === '1' ? 'card--status-pending' : 'card--status-confirm'
    },
    totalPrice() {
      if (this.event.price_type) {
        let {event: {price_list}, numplaces} = this.event;

        let priceVal = price_list.filter(el => el.type === this.event.price_type)
        if (priceVal.length) {
          priceVal = parseInt(priceVal[0].priceperplace)

          let finalPrice = numplaces * priceVal;
          return `${finalPrice.toFixed(2)} CHF`
        }

      }

      let {event: {priceperplace}, numplaces} = this.event;
      let acutalPrice = parseInt(priceperplace);
      let finalPrice = numplaces * acutalPrice;

      return `${finalPrice.toFixed(2)} CHF`


    }
  },
  mounted() {
  },
  methods: {
    ...mapActions('myEvents', ['deleteSelectedEvent']),
    invoiceLink(id) {
      return `https://api.flohmarktkoenig.ch/v1/reservations/${id}/invoice`
      // return `http://localhost:8000/v1/reservations/${id}/invoice`
      // return `https://dev-api.flohmarktkoenig.ch/v1/reservations/${id}/invoice`
    },
    deleteEventHandler(id) {
      Swal.fire({
        title: 'Sind Sie sicher?',
        text: 'Sind Sie sicher, dass Sie die Buchung löschen wollen?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, ich bin sicher!',
        cancelButtonText: 'Abbrechen'
      }).then((result) => {
        if (result.value) {
          this.deleteSelectedEvent(id)
              .then(res => {
                if (res.success) Swal.fire('Erledigt', 'Die Buchung wurde gelöscht.', 'success')
              })
              .catch(e => {
                if (e.success === false) Swal.fire('Achtung', 'Etwas falsch passiert.', 'error')
              })
        }
      })
    },
    openHandler() {
      this.isOpened = true
    },
    showPlansHandler() {
      let options = {
        counterEl: true,
        showHideOpacity: true,
        arrowEl: true,
        arrowKeys: true,
      };
      bookingPlansPhotoSwipe(this.plansList);
    }
  }
}
</script>
<style lang="scss">
.event-card__number {
  margin-top: 1rem;
}

.event-card__plan {
  margin-top: 1rem;
}

.show__plan {
  color: #ffad08;
}
</style>
